import { render, staticRenderFns } from "./editFeePrintPage.vue?vue&type=template&id=01d2deb4"
import script from "./editFeePrintPage.vue?vue&type=script&lang=js"
export * from "./editFeePrintPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports